module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Foreword"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('b', [_vm._v("Foreword")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("his work concerns a passing era as new men and new ideas replaced what had been seen as traditional values. General Sir Ian Hamilton and his command of the forces at Gallipoli in 1915, the subject of this book, was already outmoded, as was the British Army when it set out to defeat the enemies of the British Empire. Hamilton was totally confident that he would defeat the Turks as he was a gentleman and British; his confidence was misplaced. The world had turned and he was about to become unstuck. To add to his miseries at Gallipoli he was to find that he was outmanoeuvred politically and not only by politicians. Hamilton’s frustrations were to be compounded by the political use of the popular media to convince the British general public that failure was the fault of one man and not of the politicians which had sent him poorly prepared for a major offensive. Little has changed since 1915.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I have a few people to thank for their help in the preparation and writing of this work. The biggest debt I owe is to the staff at the Liddle Hart Centre for Military Archives, King’s College, London, notably Diana Manipud, who always ensured that I had material available to work from and Lianne Smith, the Archives Services Manager, who helped greatly with the supply of images for this book. I would also like to thank the staff at Special Collections, Brotherton Library, University of Leeds, for their unfailing help and assistance. Special Collections at Leeds is an underused source and is worthy of greater attention from the academic world. I would also like to thank George Anderson for his map which he produced swiftly and at a modest price.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Evan McGilvray"), _c('br'), _vm._v("Leeds, 20 February 2014")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17cb0162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Foreword.vue
// module id = 75
// module chunks = 0